module.exports = __webpack_public_path__ + "static/media/fincons_group.8aad0f20.png";